/**
 * @generated SignedSource<<52fb32edf3c635f4085c0585fc1573c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftHeaderLayout_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftNav_viewer">;
  readonly " $fragmentType": "NftHeaderLayout_viewer";
};
export type NftHeaderLayout_viewer$key = {
  readonly " $data"?: NftHeaderLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftHeaderLayout_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftHeaderLayout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftNav_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8c400e0d2c6c7f0ef955e6293584492b";

export default node;
